import { createContext } from 'react';
import { Page } from '../../interfaces/Page';

const PageContext = createContext<Page & { basePathPages?: string }>(null);

export default PageContext;
